import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const colors = palette('#007AD9');

export const admin = definePreset(Aura, {
  semantic: {
    primary: colors,
  },
  components: {
    checkbox: {
      icon: {},
    },
    treeselect: {
      root: {
        borderRadius: '0.19rem',
      },
    },
    multiselect: {
      root: {
        borderRadius: '0.19rem',
        hoverBorderColor: '#007AD9',
      },
    },
    select: {
      root: {
        borderRadius: '0.19rem',
      },
    },
  },
});
